/*
 * Frontend-only collapse for long "Diseños" submenus (Por Modelo / Por Color).
 * Does not touch the Shopify menu data — only reorders/hides DOM nodes.
 */
document.addEventListener('DOMContentLoaded', () => {
  const VISIBLE_COUNT = 5;

  const PRIORITY_ORDER = {
    'por modelo': ['Flora', 'Mallorca', 'Pétalo', 'Giulia XL', 'Clavelin'],
    'por color': ['Dorado', 'Plateado'],
  };

  const COLLAPSIBLE_COLUMNS = ['por modelo', 'por color'];

  function getColumns() {
    const columns = [];

    // Desktop mega menu: <li> > a.mega-menu__link--level-2 (heading) + ul.list-unstyled (items)
    document.querySelectorAll('.mega-menu__list > li').forEach((li) => {
      const heading = li.querySelector(':scope > a.mega-menu__link--level-2');
      const list = li.querySelector(':scope > ul.list-unstyled');
      if (heading && list) columns.push({ heading, list });
    });

    // Mobile drawer: <li> > details > summary (heading) + .menu-drawer__submenu > ul.menu-drawer__menu (items)
    document.querySelectorAll('.menu-drawer__submenu > .menu-drawer__inner-submenu > ul.menu-drawer__menu > li').forEach((li) => {
      const details = li.querySelector(':scope > details');
      if (!details) return;
      const heading = details.querySelector(':scope > summary');
      const list = details.querySelector(':scope > .menu-drawer__submenu > ul.menu-drawer__menu');
      if (heading && list) columns.push({ heading, list });
    });

    return columns;
  }

  function reorderPriorityItems(list, priorityTitles) {
    const items = Array.from(list.children).filter((el) => el.tagName === 'LI');
    const remaining = items.slice();
    const ordered = [];

    priorityTitles.forEach((title) => {
      const index = remaining.findIndex((li) => li.textContent.trim().includes(title));
      if (index !== -1) ordered.push(remaining.splice(index, 1)[0]);
    });

    ordered.concat(remaining).forEach((li) => list.appendChild(li));
  }

  function collapseColumn(list) {
    const items = Array.from(list.children).filter((el) => el.tagName === 'LI');
    if (items.length <= VISIBLE_COUNT) return;

    items.forEach((li, index) => {
      if (index >= VISIBLE_COUNT) li.hidden = true;
    });

    const toggleItem = document.createElement('li');
    toggleItem.className = 'mega-menu__submenu-toggle-item';

    const toggleButton = document.createElement('button');
    toggleButton.type = 'button';
    toggleButton.className = 'mega-menu__link mega-menu__submenu-toggle';
    toggleButton.setAttribute('aria-expanded', 'false');
    toggleButton.innerHTML = 'Ver todo <span aria-hidden="true">&#9662;</span>';

    toggleButton.addEventListener('click', () => {
      const expanded = toggleButton.getAttribute('aria-expanded') === 'true';
      items.forEach((li, index) => {
        if (index >= VISIBLE_COUNT) li.hidden = expanded;
      });
      toggleButton.setAttribute('aria-expanded', String(!expanded));
      toggleButton.innerHTML = expanded
        ? 'Ver todo <span aria-hidden="true">&#9662;</span>'
        : 'Ver menos <span aria-hidden="true">&#9652;</span>';
    });

    toggleItem.appendChild(toggleButton);
    list.appendChild(toggleItem);
  }

  getColumns().forEach(({ heading, list }) => {
    const key = heading.textContent.trim().toLowerCase();
    if (!COLLAPSIBLE_COLUMNS.includes(key)) return;

    const priorityTitles = PRIORITY_ORDER[key];
    if (priorityTitles) reorderPriorityItems(list, priorityTitles);

    collapseColumn(list);
  });
});
